import TopBar from '../components/topbar';

export default function Layout({ children, topLeft = null, topRight = null, middle = null, className= '', hideTop  = false }) {
    return (
        <div id={'content'} className={`content ${className}`}>
            {
                hideTop !== true &&
                <TopBar />

            }
            <div className="layout-container">
                { (topLeft || topRight) && <div className="website__topbar">
                    { topLeft }
                    { topRight }
                </div> }

                { middle && <div className="layout">
                    <div className="layout__middle">{ middle }</div>
                </div> }

                <div className="layout">
                    { children }
                </div>
            </div>
        </div>
    )
}
